import smoothscroll from 'smoothscroll-polyfill'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import utc from 'dayjs/plugin/utc'
import timeZone from 'dayjs/plugin/timezone'
import { setUpVeeValidate } from '~/src/js/vee-validate'
import { setUpVue } from '~/src/js/vue'

export default {
  start: () => {
    smoothscroll.polyfill()

    dayjs.extend(isSameOrBefore)
    dayjs.extend(isSameOrAfter)
    dayjs.extend(utc)
    dayjs.extend(timeZone)
    dayjs.tz.setDefault('Asia/Tokyo')

    setUpVeeValidate()
    setUpVue()
  }
}
